module.exports = __webpack_public_path__ + "static/media/EngweLogo.5eab9220.avif";